export default __webpack_public_path__ + "static/media/skovstykket-tenancy-13.d1605f2d.jpg";